import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export function NativeIcon({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="20"
        fill="none"
        viewBox="0 0 21 20"
      >
        <path
          fill="#0055B8"
          fillRule="evenodd"
          d="M7.167 1.667c.46 0 .833.373.833.833v.833h4.167a.833.833 0 010 1.667h-1.393a15.875 15.875 0 01-2.303 5.53c.238.147.474.273.704.377a.833.833 0 11-.683 1.52 7.995 7.995 0 01-1.022-.557 15.27 15.27 0 01-4.932 3.876.833.833 0 11-.742-1.492c1.7-.845 3.166-2 4.35-3.4-.95-.859-1.78-1.924-2.247-3.03a.833.833 0 011.535-.648c.338.799.96 1.629 1.713 2.335A14.173 14.173 0 009.066 5h-6.9a.833.833 0 010-1.667h4.167V2.5c0-.46.374-.833.834-.833zm6.54 6.09a1.25 1.25 0 011.087 0c.298.144.46.395.54.53.085.142.172.323.257.5l3.994 8.353a.833.833 0 11-1.503.72L16.714 15h-4.928l-1.367 2.86a.833.833 0 11-1.504-.72l3.982-8.325.013-.027c.085-.178.171-.359.255-.5.08-.136.243-.387.542-.531zm-1.124 5.576h3.334L14.25 9.848l-1.667 3.485z"
          clipRule="evenodd"
        ></path>
      </svg>
    </div>
  )
}

NativeIcon.propTypes = {
  className: PropTypes.string,
}

export function CopywriterIcon({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 20 20"
      >
        <path
          fill="#0055B8"
          fillRule="evenodd"
          d="M6.574 3.333C4.23 3.333 2.5 5.612 2.5 7.9c0 1.101.428 2.2 1.14 3.262.712 1.061 1.678 2.04 2.675 2.88.994.838 1.996 1.52 2.759 1.992.38.235.698.416.921.537l.005.002.005-.002c.222-.12.54-.302.921-.538a23.777 23.777 0 002.76-1.99c.996-.841 1.962-1.82 2.674-2.88C17.072 10.1 17.5 9 17.5 7.9c0-2.288-1.73-4.567-4.074-4.567-1.368 0-2.257.682-2.792 1.31a.833.833 0 01-1.268 0c-.536-.628-1.424-1.31-2.792-1.31zM.834 7.9c0-2.924 2.214-6.233 5.74-6.233 1.523 0 2.648.592 3.426 1.259a5.152 5.152 0 013.426-1.26c3.526 0 5.74 3.31 5.74 6.234 0 1.538-.595 2.958-1.422 4.19-.828 1.235-1.917 2.327-2.985 3.226a25.44 25.44 0 01-2.956 2.135c-.407.252-.753.45-1.007.586a8.408 8.408 0 01-.315.163 2.649 2.649 0 01-.2.086.932.932 0 01-.076.022h-.001c-.021.006-.101.025-.204.025-.103 0-.183-.02-.204-.025a.94.94 0 01-.156-.052 2.646 2.646 0 01-.121-.056 8.358 8.358 0 01-.316-.163c-.253-.136-.599-.334-1.006-.586a25.445 25.445 0 01-2.956-2.135c-1.068-.9-2.158-1.991-2.985-3.225C1.429 10.858.833 9.438.833 7.9z"
          clipRule="evenodd"
        ></path>
      </svg>
    </div>
  )
}

CopywriterIcon.propTypes = {
  className: PropTypes.string,
}

export function ReviserIcon({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 20 20"
      >
        <path
          fill="#0055B8"
          fillRule="evenodd"
          d="M13.16 2.327a2.601 2.601 0 113.68 3.679L6.37 16.475l-.049.049c-.24.24-.45.452-.705.608a2.498 2.498 0 01-.723.299c-.29.07-.59.07-.928.069H2.5a.833.833 0 01-.833-.833V15.27v-.07c0-.338-.001-.637.069-.928a2.5 2.5 0 01.299-.722c.156-.255.368-.466.608-.706l.049-.049L13.16 2.327zm2.5 1.179a.934.934 0 00-1.32 0L3.87 13.975c-.316.316-.374.382-.414.447a.833.833 0 00-.1.24c-.017.074-.023.162-.023.61v.561h.562c.448 0 .536-.005.61-.023a.833.833 0 00.24-.1c.065-.039.13-.097.447-.414L15.66 4.827a.934.934 0 000-1.321zm2.402 10.879c.34.31.363.838.053 1.177l-.833.912A3.092 3.092 0 0115 17.5c-.871 0-1.69-.38-2.281-1.026a1.43 1.43 0 00-1.052-.482c-.38 0-.76.163-1.053.483a.833.833 0 11-1.228-1.127 3.096 3.096 0 012.28-1.023c.871 0 1.69.378 2.282 1.023v.001c.293.32.673.484 1.052.484s.759-.164 1.051-.484l.834-.911a.833.833 0 011.177-.053z"
          clipRule="evenodd"
        ></path>
      </svg>
    </div>
  )
}

ReviserIcon.propTypes = {
  className: PropTypes.string,
}

export function QualityIcon({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="20"
        fill="none"
        viewBox="0 0 21 20"
      >
        <path
          fill="#0055B8"
          fillRule="evenodd"
          d="M7.799.833H13.2c.67 0 1.224 0 1.675.037.469.039.9.12 1.304.327.627.32 1.137.83 1.457 1.457.206.404.288.835.326 1.303C18 4.408 18 4.962 18 5.632v4.785a.833.833 0 11-1.667 0v-4.75c0-.714 0-1.2-.031-1.574-.03-.366-.084-.552-.15-.683a1.667 1.667 0 00-.729-.728c-.13-.067-.317-.12-.682-.15-.375-.031-.86-.032-1.574-.032H7.833c-.713 0-1.199 0-1.574.031-.365.03-.552.084-.682.15-.314.16-.569.416-.729.73-.066.13-.12.316-.15.682-.03.375-.031.86-.031 1.574v8.666c0 .714 0 1.2.031 1.575.03.365.084.552.15.682.16.314.415.569.729.729.13.066.317.12.682.15.375.03.86.031 1.574.031H10.5a.833.833 0 010 1.667H7.799c-.67 0-1.225 0-1.676-.037-.468-.038-.899-.12-1.303-.326a3.333 3.333 0 01-1.457-1.457c-.206-.405-.288-.835-.326-1.304C3 15.593 3 15.04 3 14.368V5.632c0-.67 0-1.224.037-1.675.038-.468.12-.899.326-1.303.32-.628.83-1.138 1.457-1.457C5.224.99 5.655.909 6.123.87 6.574.833 7.128.833 7.8.833zm-1.466 5c0-.46.373-.833.834-.833h6.666a.833.833 0 110 1.667H7.167a.833.833 0 01-.834-.833zm0 3.334c0-.46.373-.833.834-.833h5a.833.833 0 010 1.666h-5a.833.833 0 01-.834-.833zm0 3.333c0-.46.373-.833.834-.833h1.666a.833.833 0 010 1.667H7.167a.833.833 0 01-.834-.834zm12.256.66a.833.833 0 010 1.18l-3.75 3.75a.833.833 0 01-1.178 0l-1.667-1.667a.833.833 0 111.179-1.179l1.077 1.078 3.16-3.161a.834.834 0 011.18 0z"
          clipRule="evenodd"
        ></path>
      </svg>
    </div>
  )
}

QualityIcon.propTypes = {
  className: PropTypes.string,
}

export function CreativeIcon({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="20"
        fill="none"
        viewBox="0 0 21 20"
      >
        <path
          fill="#0055B8"
          fillRule="evenodd"
          d="M3.833 7.5a6.667 6.667 0 1110 5.775v.085c0 .366 0 .681-.018.942-.018.275-.06.55-.172.822a2.5 2.5 0 01-1.353 1.353 2.557 2.557 0 01-.821.172c-.261.018-.577.018-.942.018h-.054c-.365 0-.68 0-.942-.018a2.556 2.556 0 01-.821-.172 2.5 2.5 0 01-1.353-1.354 2.557 2.557 0 01-.173-.82 14.849 14.849 0 01-.017-.943v-.085A6.664 6.664 0 013.833 7.5zm6.667-5a5 5 0 00-2.143 9.52c.291.138.476.43.476.752v.562c0 .4 0 .657.014.855.013.19.035.262.05.297a.833.833 0 00.45.45.963.963 0 00.298.05c.197.014.455.014.855.014.4 0 .658 0 .855-.014a.964.964 0 00.297-.05.834.834 0 00.451-.45.97.97 0 00.05-.297c.013-.198.014-.456.014-.855v-.562c0-.322.185-.614.475-.753A5 5 0 0010.5 2.5zM8 8.334c0-.46.373-.834.833-.834h3.334a.833.833 0 010 1.667h-.834v4.167a.833.833 0 01-1.666 0V9.167h-.834A.833.833 0 018 8.334zm-.417 10c0-.46.373-.834.834-.834h4.166a.833.833 0 010 1.667H8.417a.833.833 0 01-.834-.834z"
          clipRule="evenodd"
        ></path>
      </svg>
    </div>
  )
}

CreativeIcon.propTypes = {
  className: PropTypes.string,
}

export function AutomaticIcon({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width="18" height="20" viewBox="0 0 18 20">
        <path
          fill="#0055B8"
          fillRule="evenodd"
          d="M21 21a1 1 0 01-2 0v-2a3 3 0 00-3-3H8a3 3 0 00-3 3v2a1 1 0 01-2 0v-2a5 5 0 015-5h8a5 5 0 015 5v2zm-9-9a5 5 0 110-10 5 5 0 010 10zm0-2a3 3 0 100-6 3 3 0 000 6z"
          transform="translate(-3 -2)"
          className="0"
        ></path>
      </svg>
    </div>
  )
}

AutomaticIcon.propTypes = {
  className: PropTypes.string,
}

export function LightIcon({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width="20" height="23" viewBox="0 0 20 23">
        <path
          fill="#0055B8"
          fillRule="evenodd"
          d="M10.867 15H3a1 1 0 01-.768-1.64l10-12c.639-.767 1.884-.227 1.76.764L13.132 9H21a1 1 0 01.768 1.64l-10 12c-.639.767-1.884.227-1.76-.764l.86-6.876zm.718-9.74L5.135 13H12a1 1 0 01.992 1.124l-.577 4.616 6.45-7.74H12a1 1 0 01-.992-1.124l.577-4.616z"
          transform="translate(-2 -1)"
          className="0"
        ></path>
      </svg>
    </div>
  )
}

LightIcon.propTypes = {
  className: PropTypes.string,
}

export function FileCheckIcon({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.7587 1L14 1C14.2652 1 14.5196 1.10536 14.7071 1.29289L20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V17.2413C21 18.0463 21 18.7106 20.9558 19.2518C20.9099 19.8139 20.8113 20.3306 20.564 20.816C20.1805 21.5686 19.5686 22.1805 18.816 22.564C18.3306 22.8113 17.8139 22.9099 17.2518 22.9558C16.7106 23 16.0463 23 15.2413 23H8.75868C7.95372 23 7.28936 23 6.74817 22.9558C6.18608 22.9099 5.66937 22.8113 5.18404 22.564C4.43139 22.1805 3.81947 21.5686 3.43597 20.816C3.18868 20.3306 3.09012 19.8139 3.04419 19.2518C2.99998 18.7106 2.99999 18.0463 3 17.2413V6.7587C2.99999 5.95373 2.99998 5.28937 3.04419 4.74817C3.09012 4.18608 3.18868 3.66937 3.43597 3.18404C3.81947 2.43139 4.43139 1.81947 5.18404 1.43597C5.66937 1.18868 6.18608 1.09012 6.74817 1.04419C7.28937 0.999977 7.95373 0.999988 8.7587 1ZM6.91104 3.03755C6.47262 3.07337 6.24842 3.1383 6.09202 3.21799C5.7157 3.40973 5.40973 3.7157 5.21799 4.09202C5.1383 4.24842 5.07337 4.47262 5.03755 4.91104C5.00078 5.36113 5 5.94342 5 6.8V17.2C5 18.0566 5.00078 18.6389 5.03755 19.089C5.07337 19.5274 5.1383 19.7516 5.21799 19.908C5.40973 20.2843 5.7157 20.5903 6.09202 20.782C6.24842 20.8617 6.47262 20.9266 6.91104 20.9624C7.36113 20.9992 7.94342 21 8.8 21H15.2C16.0566 21 16.6389 20.9992 17.089 20.9624C17.5274 20.9266 17.7516 20.8617 17.908 20.782C18.2843 20.5903 18.5903 20.2843 18.782 19.908C18.8617 19.7516 18.9266 19.5274 18.9624 19.089C18.9992 18.6389 19 18.0566 19 17.2V9.00007L15.5681 9.00007C15.3157 9.0001 15.0699 9.00013 14.8618 8.98313C14.6332 8.96445 14.3634 8.92038 14.092 8.78208C13.7157 8.59034 13.4097 8.28438 13.218 7.90805C13.0797 7.63663 13.0356 7.3669 13.0169 7.1383C12.9999 6.93014 13 6.68434 13 6.43195L13 3H8.8C7.94342 3 7.36113 3.00078 6.91104 3.03755ZM15 4.41421L17.5859 7.00007H15.6C15.3035 7.00007 15.1412 6.99929 15.0246 6.98977C15.02 6.98939 15.0156 6.98901 15.0114 6.98862C15.0111 6.98447 15.0107 6.98008 15.0103 6.97544C15.0008 6.85885 15 6.6966 15 6.40007V4.41421ZM16.2071 12.7929C16.5976 13.1834 16.5976 13.8166 16.2071 14.2071L11.7071 18.7071C11.3166 19.0976 10.6834 19.0976 10.2929 18.7071L8.29289 16.7071C7.90237 16.3166 7.90237 15.6834 8.29289 15.2929C8.68342 14.9024 9.31658 14.9024 9.70711 15.2929L11 16.5858L14.7929 12.7929C15.1834 12.4024 15.8166 12.4024 16.2071 12.7929Z"
          fill="#0055B8"
        />
      </svg>
    </div>
  )
}

FileCheckIcon.propTypes = {
  className: PropTypes.string,
}

export function UserCheckIcon({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2929 2.29289C10.6834 1.90237 11.3166 1.90237 11.7071 2.29289L15.7071 6.29289C16.0976 6.68342 16.0976 7.31658 15.7071 7.70711L11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071C9.90237 11.3166 9.90237 10.6834 10.2929 10.2929L12.5858 8H4C3.44772 8 3 7.55229 3 7C3 6.44772 3.44772 6 4 6H12.5858L10.2929 3.70711C9.90237 3.31658 9.90237 2.68342 10.2929 2.29289ZM15.2929 12.2929C15.6834 11.9024 16.3166 11.9024 16.7071 12.2929L20.7071 16.2929C21.0976 16.6834 21.0976 17.3166 20.7071 17.7071L16.7071 21.7071C16.3166 22.0976 15.6834 22.0976 15.2929 21.7071C14.9024 21.3166 14.9024 20.6834 15.2929 20.2929L17.5858 18H4C3.44772 18 3 17.5523 3 17C3 16.4477 3.44772 16 4 16H17.5858L15.2929 13.7071C14.9024 13.3166 14.9024 12.6834 15.2929 12.2929Z"
          fill="#0055B8"
        />
      </svg>
    </div>
  )
}

UserCheckIcon.propTypes = {
  className: PropTypes.string,
}

export function StarIcon({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.5 1C5.05228 1 5.5 1.44772 5.5 2V3.5H7C7.55228 3.5 8 3.94772 8 4.5C8 5.05228 7.55228 5.5 7 5.5H5.5V7C5.5 7.55228 5.05228 8 4.5 8C3.94772 8 3.5 7.55228 3.5 7V5.5H2C1.44772 5.5 1 5.05228 1 4.5C1 3.94772 1.44772 3.5 2 3.5H3.5V2C3.5 1.44772 3.94772 1 4.5 1ZM13 2C13.4138 2 13.7848 2.25483 13.9333 2.64102L15.6675 7.14988C15.9679 7.93093 16.0623 8.156 16.1914 8.33759C16.321 8.5198 16.4802 8.67899 16.6624 8.80855C16.844 8.93768 17.0691 9.03207 17.8501 9.33248L22.359 11.0667C22.7452 11.2152 23 11.5862 23 12C23 12.4138 22.7452 12.7848 22.359 12.9333L17.8501 14.6675C17.0691 14.9679 16.844 15.0623 16.6624 15.1914C16.4802 15.321 16.321 15.4802 16.1914 15.6624C16.0623 15.844 15.9679 16.0691 15.6675 16.8501L13.9333 21.359C13.7848 21.7452 13.4138 22 13 22C12.5862 22 12.2152 21.7452 12.0667 21.359L10.3325 16.8501C10.0321 16.0691 9.93768 15.844 9.80855 15.6624C9.67899 15.4802 9.5198 15.321 9.33759 15.1914C9.156 15.0623 8.93093 14.9679 8.14988 14.6675L3.64102 12.9333C3.25483 12.7848 3 12.4138 3 12C3 11.5862 3.25483 11.2152 3.64102 11.0667L8.14988 9.33248C8.93093 9.03207 9.156 8.93768 9.33759 8.80855C9.5198 8.67899 9.67899 8.5198 9.80855 8.33759C9.93768 8.156 10.0321 7.93093 10.3325 7.14988L12.0667 2.64102C12.2152 2.25483 12.5862 2 13 2ZM13 5.78568L12.1992 7.86784C12.1859 7.90231 12.1728 7.93634 12.1599 7.96993C11.9164 8.60419 11.7324 9.0833 11.4385 9.49658C11.1794 9.861 10.861 10.1794 10.4966 10.4385C10.0833 10.7324 9.60419 10.9164 8.96994 11.1599C8.93634 11.1728 8.90232 11.1859 8.86784 11.1992L6.78568 12L8.86784 12.8008C8.90232 12.8141 8.93634 12.8272 8.96993 12.8401C9.60419 13.0836 10.0833 13.2676 10.4966 13.5615C10.861 13.8206 11.1794 14.139 11.4385 14.5034C11.7324 14.9167 11.9164 15.3958 12.1599 16.0301C12.1728 16.0637 12.1859 16.0977 12.1992 16.1322L13 18.2143L13.8008 16.1322C13.8141 16.0977 13.8272 16.0637 13.8401 16.0301C14.0836 15.3958 14.2676 14.9167 14.5615 14.5034C14.8206 14.139 15.139 13.8206 15.5034 13.5615C15.9167 13.2676 16.3958 13.0836 17.0301 12.8401C17.0637 12.8272 17.0977 12.8141 17.1322 12.8008L19.2143 12L17.1322 11.1992C17.0977 11.1859 17.0637 11.1728 17.0301 11.1599C16.3958 10.9164 15.9167 10.7324 15.5034 10.4385C15.139 10.1794 14.8206 9.861 14.5615 9.49658C14.2676 9.08331 14.0836 8.60419 13.8401 7.96994C13.8272 7.93635 13.8141 7.90232 13.8008 7.86784L13 5.78568ZM4.5 16C5.05228 16 5.5 16.4477 5.5 17V18.5H7C7.55228 18.5 8 18.9477 8 19.5C8 20.0523 7.55228 20.5 7 20.5H5.5V22C5.5 22.5523 5.05228 23 4.5 23C3.94772 23 3.5 22.5523 3.5 22V20.5H2C1.44772 20.5 1 20.0523 1 19.5C1 18.9477 1.44772 18.5 2 18.5H3.5V17C3.5 16.4477 3.94772 16 4.5 16Z"
          fill="#0055B8"
        />
      </svg>
    </div>
  )
}

StarIcon.propTypes = {
  className: PropTypes.string,
}

export function PaletteIcon({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C13.1046 21 14 20.1046 14 19V18.5C14 18.4767 14 18.4538 14 18.4312C13.9999 18.0338 13.9998 17.7393 14.0342 17.4779C14.2705 15.683 15.683 14.2705 17.4779 14.0342C17.7394 13.9998 18.0338 13.9999 18.4312 14C18.4538 14 18.4767 14 18.5 14H19C20.1046 14 21 13.1046 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 14.2091 21.2091 16 19 16H18.5C18.0038 16 17.8525 16.0022 17.7389 16.0171C16.8415 16.1353 16.1353 16.8415 16.0171 17.7389C16.0022 17.8525 16 18.0038 16 18.5V19C16 21.2091 14.2091 23 12 23C5.92487 23 1 18.0751 1 12ZM8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7ZM14 8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8C18 9.10457 17.1046 10 16 10C14.8954 10 14 9.10457 14 8ZM5 12C5 10.8954 5.89543 10 7 10C8.10457 10 9 10.8954 9 12C9 13.1046 8.10457 14 7 14C5.89543 14 5 13.1046 5 12Z"
          fill="#0055B8"
        />
      </svg>
    </div>
  )
}

PaletteIcon.propTypes = {
  className: PropTypes.string,
}

export function ChartIcon({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 22H4.6C3.95 22 3.52 22 3.09 21.78C2.71 21.59 2.41 21.28 2.22 20.9C2 20.47 2 20.04 2 19.39V3C2 2.45 2.45 2 3 2C3.55 2 4 2.45 4 3V19.4C4 19.68 4 19.97 4.02 20.05C4.03 20 4.32 20 4.6 20H21C21.55 20 22 20.45 22 21C22 21.55 21.55 22 21 22ZM7 16C6.74 16 6.49 15.9 6.29 15.71C5.9 15.32 5.9 14.69 6.29 14.3L10.72 9.87C10.98 9.61 11.19 9.4 11.53 9.29C11.83 9.19 12.16 9.19 12.46 9.29C12.8 9.4 13 9.61 13.26 9.87L14.99 11.6L18.57 8.02H16.98C16.43 8.02 15.98 7.57 15.98 7.02C15.98 6.47 16.43 6.02 16.98 6.02H20.98C21.11 6.02 21.24 6.05 21.36 6.1C21.48 6.15 21.59 6.22 21.69 6.32C21.79 6.42 21.86 6.53 21.91 6.65C21.96 6.77 21.99 6.89 21.99 7.03V11.03C21.99 11.58 21.54 12.03 20.99 12.03C20.44 12.03 19.99 11.58 19.99 11.03V9.44L16.26 13.17C16 13.43 15.79 13.64 15.45 13.75C15.15 13.85 14.82 13.85 14.52 13.75C14.18 13.64 13.98 13.43 13.72 13.17L11.99 11.44L7.7 15.73C7.5 15.93 7.25 16.02 6.99 16.02L7 16Z"
          fill="#0055B8"
        />
      </svg>
    </div>
  )
}

ChartIcon.propTypes = {
  className: PropTypes.string,
}

export function ShieldIcon({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7137 1.08867C11.9034 1.06126 12.0961 1.06126 12.2858 1.08867C12.5044 1.12027 12.7079 1.19712 12.8694 1.25815C12.8842 1.26373 12.8986 1.26919 12.9127 1.27446L18.2745 3.28513C18.3184 3.3016 18.362 3.31786 18.4051 3.33398C19.0229 3.56463 19.5655 3.76719 19.9833 4.13541C20.3488 4.45753 20.6304 4.86383 20.8036 5.31917C21.0017 5.83968 21.0009 6.4188 20.9999 7.07824C20.9998 7.12434 20.9998 7.17083 20.9998 7.21772V12.0001C20.9998 14.8267 19.4625 17.1833 17.8007 18.9145C16.1278 20.6573 14.2138 21.8883 13.2017 22.4787C13.1883 22.4865 13.1747 22.4946 13.1607 22.5028C12.976 22.6112 12.7363 22.752 12.4191 22.82C12.1597 22.8756 11.8399 22.8756 11.5804 22.82C11.2633 22.752 11.0235 22.6112 10.8388 22.5028C10.8249 22.4946 10.8112 22.4865 10.7979 22.4787C9.78577 21.8883 7.87174 20.6573 6.19884 18.9145C4.53707 17.1833 2.99978 14.8267 2.99978 12.0001V7.21772C2.99978 7.17083 2.99971 7.12434 2.99964 7.07825C2.99869 6.4188 2.99785 5.83968 3.19592 5.31917C3.36919 4.86383 3.65075 4.45753 4.01626 4.13541C4.43409 3.76719 4.97663 3.56463 5.59442 3.33398C5.6376 3.31786 5.68116 3.3016 5.72506 3.28513L11.0869 1.27446C11.1009 1.26919 11.1154 1.26373 11.1301 1.25815C11.2917 1.19712 11.4951 1.12027 11.7137 1.08867ZM11.9968 3.07139C11.9559 3.08478 11.9005 3.10534 11.7891 3.14712L6.4273 5.15779C5.60207 5.46726 5.44325 5.54366 5.33861 5.63588C5.21677 5.74325 5.12291 5.87868 5.06516 6.03047C5.01555 6.16083 4.99978 6.33636 4.99978 7.21772V12.0001C4.99978 14.0819 6.13947 15.9646 7.64169 17.5296C9.13278 19.083 10.8698 20.2052 11.8057 20.7512C11.8629 20.7846 11.9042 20.8087 11.94 20.8289C11.9682 20.8447 11.9869 20.8547 11.9998 20.8612C12.0126 20.8547 12.0314 20.8447 12.0595 20.8289C12.0954 20.8087 12.1367 20.7846 12.1939 20.7512C13.1298 20.2052 14.8668 19.083 16.3579 17.5295C17.8601 15.9646 18.9998 14.0819 18.9998 12.0001V7.21772C18.9998 6.33636 18.984 6.16083 18.9344 6.03047C18.8766 5.87868 18.7828 5.74325 18.6609 5.63588C18.5563 5.54366 18.3975 5.46726 17.5722 5.15779L12.2105 3.14712C12.099 3.10534 12.0436 3.08478 12.0028 3.07139C12.0017 3.07104 12.0007 3.07072 11.9998 3.0704C11.9988 3.07072 11.9978 3.07104 11.9968 3.07139Z"
          fill="#0055B8"
        />
      </svg>
    </div>
  )
}

ShieldIcon.propTypes = {
  className: PropTypes.string,
}
